(function () {
    'use strict';

    angular
        .module('app.shared')
        .directive('csvDownload', csvDownload)
        .config([
            '$compileProvider',
            function ($compileProvider) {
                $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|tel|file|blob|chrome-extension|data|local):/);
                // $compileProvider.aHrefSanitizationWhitelist(/^\s*(data|https?|ftp|mailto|chrome-extension):/);
                // Angular before v1.2 uses $compileProvider.urlSanitizationWhitelist(...)
            }]);


    csvDownload.$inject = ["$sce"];

    function csvDownload($sce) {
        return {
            restrict: 'A',
            //transclude: true,
            link: link,
            //template: '<a href=\"{{hreflink}}\" download=\"{{filename}}\">{{label}}</a>', // TODO ng-href
            // <button ng-if=\"{{button}} === \'true\'\">{{label}}</button>
            scope: {
                columnHeader: '=',
                inputArray: '='
            }
        };

        
        function link($scope, $element, $attrs) {

            var download = null;
            
            $element.on("click", function () {
                window.open(download, "_download");
            });
            $element.style = "cursor:pointer; font-weight:bold;";

            var getHeader = function () {
                if ($scope.columnHeader) {
                    return $scope.columnHeader;
                }

                // no header, so build it
                $scope.columnHeader = [];
                // loop through all data in case some objects are incomplete
                for (var i in $scope.inputArray) {
                    var keys = Object.keys($scope.inputArray[i]);
                    for (var j in keys) {
                        var key = keys[j];
                        $scope.columnHeader[key] = key;
                    }
                }

                return $scope.columnHeader;
            };

            // the biggest difference here is I'm using the header instead of the keys for the header row
            var convertArrayOfObjectsToCSV = function () {
                var result, ctr, keys, columnDelimiter, lineDelimiter;

                var header = getHeader() || null;
                if (header === null) {
                    return null;
                }

                columnDelimiter = ',';
                lineDelimiter = '\n';

                keys = Object.keys(header);

                result = '';
                keys.forEach(function (key) {
                    var dataVal = header[key];
                    if (undefined === dataVal) {
                        dataVal = '';
                    }
                    result += '\"' + dataVal + '\"' + columnDelimiter; // handle embedded commas
                });
                result += columnDelimiter;
                result += lineDelimiter;

                $scope.inputArray.forEach(function (item) {
                    ctr = 0;
                    keys.forEach(function (key) {
                        if (ctr > 0) {
                            result += columnDelimiter;
                        }
                        var dataVal = item[key];
                        if (undefined === dataVal) {
                            dataVal = '';
                        }
                        result += '\"' + dataVal + '\"'; // handle embedded commas
                        ctr++;
                    });
                    result += lineDelimiter;
                });

                return result;
            };

            var generateCSVLink = function () {
                var data, link;

                
                var csv = convertArrayOfObjectsToCSV();
                if (csv === null) {
                    return;
                }

                if (!csv.match(/^data:text\/csv/i)) {
                    csv = 'data:text/csv;charset=utf-8,' + csv;
                }

                download = csv;

                //$element.hreflink = $sce.trustAsHtml(csv);

            };

            generateCSVLink();

        }
    }
})();
